module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="content-header form-group">\r\n    <h1 class="pull-left">\r\n        ';
 
    
__p+='\r\n            '+
((__t=(lang.USERS))==null?'':_.escape(__t))+
'\r\n    </h1>\r\n    ';
 
    if(role_user == 0){ 
        
__p+='\r\n\r\n        <span class="btn btn-sm btn-info btn-flat pull-right" id="addUser"><span class="glyphicon glyphicon-plus"></span>&nbsp;\r\n        '+
((__t=(lang.NEW))==null?'':_.escape(__t))+
'\r\n            </span>\r\n            ';
 } 
__p+='\r\n                <div class="clear"></div>\r\n</section>\r\n<section class="content">\r\n    <div class="row">\r\n        <div class="col-md-12">\r\n            <div class="gtable-responsive col-md-12 spaced">\r\n                <table id="userData"></table>\r\n            </div>\r\n        </div>\r\n        <div class="col-md-12">\r\n            <div id="paginationHolder"></div>\r\n        </div>\r\n    </div>\r\n</section>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/users/usersView.ejs
// module id = 450
// module chunks = 0